import React, { useContext } from "react"
import LocaleContext from "../../../../../context/LocaleContext"
import translate, { keys } from "../../../../../translation/translator"
import HeroSectionDescriptionStyle from "./HeroSectionDescriptionStyle.module.styl"
import { Link } from "gatsby"

const HeroSectionDescription = () => {
  const locale = useContext(LocaleContext).locale
  return (
    <div className={HeroSectionDescriptionStyle.description_holder}>
      <p className={HeroSectionDescriptionStyle.description}>
        {translate(keys.INDEX_HERO_HERE_TO_HELP, locale)}
        <span>{translate(keys.INDEX_HERO_NEW_DIAGNOSE, locale)}</span>
      </p>
      <Link to="/first-steps" className={HeroSectionDescriptionStyle.button}>
        {translate(keys.INDEX_HERO_FIRST_STEPS, locale)}
      </Link>
      <p className={HeroSectionDescriptionStyle.info}>
        {translate(keys.INDEX_HERO_FREE_GUIDE, locale)}
      </p>
    </div>
  )
}

export default HeroSectionDescription
